import { render, staticRenderFns } from "./OrdreEixidaCreate.vue?vue&type=template&id=16fd99ef&scoped=true"
import script from "./OrdreEixidaCreate.vue?vue&type=script&lang=js"
export * from "./OrdreEixidaCreate.vue?vue&type=script&lang=js"
import style0 from "./OrdreEixidaCreate.vue?vue&type=style&index=0&id=16fd99ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fd99ef",
  null
  
)

export default component.exports